import type { ConsignmentSummary, SrfImportOutcome, SrfImportPreview } from '../model/types';

/**
 * `POST /import-srf` answers `201` with a bare `ConsignmentSummary` and `200`
 * with `{ consignment, validationErrors }` — the file parsed, but nothing was
 * persisted. Both are success statuses, so the body shape is what tells them
 * apart: only the preview nests a consignment next to a list of failures.
 */
export const toSrfImportOutcome = (response: ConsignmentSummary | SrfImportPreview): SrfImportOutcome => {
  const preview = response as SrfImportPreview;

  return 'consignment' in response && Array.isArray(preview.validationErrors)
    ? { created: false, consignment: preview.consignment, validationErrors: preview.validationErrors }
    : { created: true, consignment: response as ConsignmentSummary };
};
